import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { TextAligning, TextBoxColors } from 'atoms/TextBox'
import { TextBoxMaxLine1FontXs } from 'atoms/TextBox/Templates'
import { TextBlock, TextBlockRowGap } from 'blocks/TextBlock'

export interface ITextBlockAccountUsername extends ITextBlockProps {
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  colorTitle?: TextBoxColors
  colorDescription?: TextBoxColors
}

export const TextBlockAccountUsername = ({
  title = '',
  description = '',
  colorTitle = TextBoxColors.TEXT_ICON_PRIMARY,
  colorDescription = TextBoxColors.TEXT_ICON_SECONDARY,
  rowGap = TextBlockRowGap.INDENT_0,
  width = 100,
  ...rest
}: ITextBlockAccountUsername) => {
  return (
    <TextBlock rowGap={rowGap} width={width} {...rest}>
      <TextBoxMaxLine1FontXs
        alignment={TextAligning.Left}
        title={title}
        color={colorTitle}
      />
      <TextBoxMaxLine1FontXs
        alignment={TextAligning.Left}
        title={description}
        color={colorDescription}
      />
    </TextBlock>
  )
}
